import React from 'react';
import { Button } from 'anf-core-react';
import TmntHtml from '../../tools/TmntHtml';

export default function ProductNotificationsButton({ brand, tmntData, displaySignupText = false }) {
  const normalizedBrand = brand === 'gh' ? 'hol' : brand;

  const handleOpenNotificationDialog = () => {
    console.log('open Dialog'); // Placeholder for actual dialog opening logic
  };

  return (
    <div className="product-notifications-button-container" data-product-brand={normalizedBrand} data-testid="product-notifications-button-container">
      {displaySignupText && (
        <div className="product-notifications-signup-text">
          <TmntHtml value={tmntData?.productNotificationSignUp?.value} />
        </div>
      )}
      <Button
        classList="product-notifications-button-container_button"
        variant="secondary"
        brand={normalizedBrand}
        isFullWidth
        onClick={handleOpenNotificationDialog}
      >
        {tmntData?.notifyMeButton?.value}
      </Button>
    </div>
  );
}
